import { apiRequest } from '@/utils/api-request';
import { UserResponse } from '@/types';

export const fetchUser = async () => {
  const response = await apiRequest<UserResponse>({
    url: '/user/current-user',
    method: 'GET',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to fetch user' };
  }

  return response;
};
